import { TCardGridFields, TCardGridProps } from '../types/cardGrid.types';
import { CardProps, StringField, TComponentParamsGeneral, THeadingTag } from '../../../types/types';
import { getFollowingHTag } from '../../../utils/seo.utils';

export class CardGridModel {
  private readonly fields?: TCardGridFields;
  private readonly params?: TComponentParamsGeneral;

  constructor(props: TCardGridProps) {
    this.fields = props?.fields;
    this.params = props?.params;
  }

  get title(): StringField | undefined {
    return this.fields?.title;
  }

  get subtitle(): StringField | undefined {
    return this.fields?.subtitle;
  }

  get cards(): Array<CardProps> {
    return this.fields?.items || [];
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }

  get headingTag(): THeadingTag {
    return (this.params?.headingTag?.toLowerCase() as THeadingTag) || 'h3';
  }

  get cardHeadingTitleTag(): THeadingTag {
    return getFollowingHTag(this.headingTag);
  }
}
